import React from "react";
import { Link } from "react-router-dom";
import "./css/Navbar.css"; // Import your stylesheet

const Navbar = () => (
  <nav
    className="navbar"
    style={{
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
      padding: "0.5rem 1rem",
      background: "#fff",
      borderBottom: "1px solid #eee",
    }}
  >
    <div>
      <Link
        to="/"
        style={{
          textDecoration: "none",
          color: "#222",
          fontWeight: "bold",
          fontSize: "1.5rem",
        }}
      >
        TasteBuds.social
      </Link>
    </div>
    <div style={{ display: "flex", gap: "1rem" }}>
      <Link to="/privacy" style={{ textDecoration: "none", color: "#555" }}>
        Privacy
      </Link>
      <Link to="/terms" style={{ textDecoration: "none", color: "#555" }}>
        Terms
      </Link>
    </div>
  </nav>
);

export default Navbar;
